const searchTypesMap = {
  owner_name: "owner_id",
  asset_id: "asset_id",
  serial_number: "serial_number",
  owner_phone_number: "owner_id",
};

export default searchTypesMap;
